export default function StatsSection() {
  const stats = [
    { icon: 'ri-movie-line', value: '10万+', label: '影视资源', description: '覆盖全球热门电影电视剧' },
    { icon: 'ri-user-star-line', value: '500万+', label: '活跃用户', description: '日均活跃用户持续增长' },
    { icon: 'ri-shield-check-line', value: '99.9%', label: '安全可靠', description: '多重安全防护保障隐私' },
    { icon: 'ri-speed-line', value: '零缓冲', label: '极速播放', description: '智能CDN加速技术加持' },
  ];

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            值得信赖的视频平台推荐
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto">
            樱花视频以客观公正的态度，为用户筛选最优质的在线视频平台
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 text-center"
            >
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                <i className={`${stat.icon} text-xl text-accent-600`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-foreground-900 mb-1">{stat.value}</div>
              <div className="text-sm font-medium text-foreground-700 mb-1">{stat.label}</div>
              <div className="text-xs text-foreground-500">{stat.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}